exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-img-wrapper[data-v-c66aa99e]{width:250px}.default-thumb[data-v-c66aa99e]{max-width:200px;width:auto}.location-product-carousel-img-wrapper[data-v-c66aa99e]{max-height:300px;text-align:center}.location-product-carousel-img-wrapper img[data-v-c66aa99e]{max-height:300px;width:auto!important;display:inline-block}", ""]);

// exports
